import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { CJHubService } from '../../../services/cjhub.service';
import { Message } from '../../../models/Message';
import { StateService } from '../../../services/state.service';
import { TranslocoService } from '@jsverse/transloco';
import { ActivatedRoute, Router } from '@angular/router';
import { BackOfficeService } from '../../../services/backoffice.service';
import { MyConfigOrganization } from '../../../models/myConfig';
import { MyConfigService } from '../../../services/my-config.service';
import { BookingConfigService } from '../../../parkifly-bookings/services/booking-config.service';
import { ParkingTimeOptions } from '../../../parkifly-bookings/data/parking-time-options.enum';
import { BackOffice24StatesService } from './state/back-office24-states.service';
import moment from 'moment';
import { DebugModalComponent } from '../../../components/debugmodal/debugmodal.component';
import { MatDialog } from '@angular/material/dialog';
import { OneUsersPaginationModel } from '../../../models/OneModels';

@Component({
  selector: 'app-back-office24',
  templateUrl: './back-office24.component.html',
  styleUrl: './back-office24.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BackOffice24Component implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  loading = true;
  loadingInitConfig = true;
  defaultOrganization: MyConfigOrganization;
  activeLang: string = 'sv';
  meTab: boolean = false;

  public demo1TabIndex = 0;
  public tabNavigationByQuery = false;

  constructor(
    private route: ActivatedRoute,
    public cjHubService: CJHubService,
    public authService: AuthService,
    public stateService: StateService,
    public translate: TranslocoService,
    private backOfficeService: BackOfficeService,
    private router: Router,
    public myConfigService: MyConfigService,
    private bookingConfig: BookingConfigService,
    public backOffice24StatesService: BackOffice24StatesService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    try {
      this.initConfig();
      this.loading = false; //Reflect on this line as you can be perplexing the user with a very annoying loading spinner ;)
    } catch (e) {
      console.log(e);
    }
    this.activeLang = this.translate.getActiveLang();
    this.translate.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
  }

  initConfig() {
    this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe(params => {
      //TODO::Should look into Guards to handle this in the future
      if(!this.myConfigService.hasBackOfficeAccess()) {
        this.router.navigate(['/admin/admin-start']);
      }

      if (this.router.url == '/admin/backoffice24/Me') {
        this.demo1TabIndex = this.myConfigService.myConfig.organizations.length;
        this.loadingInitConfig = false;
        this.meTab = true;
      }else {
        this.visibleOrganizations.forEach(org => {
          if (org.config?.backOfficeModules && org.config?.backOfficeModules?.length > 0) {
            org.config.backOfficeModules.forEach(module => {
              try {
                if (typeof module.menu.name === 'string') {
                  module.menu.name = JSON.parse(module.menu.name);
                }
                if (typeof module.menu.description === 'string') {
                  module.menu.description = JSON.parse(module.menu.description);
                }
              } catch (error) {
                console.error('Error parsing JSON:', error, module.menu);
              }
            });
          }
        });

        // Initially set the Current Organization
        if (
          params['organizationId'] != null &&
          params['organizationId'] != '' &&
          params['organizationId'] != undefined &&
          params['organizationId'] != 'undefined'
        ) {
          const orgFound = this.myConfigService.getMyConfigOrganizationById(params['organizationId'].toString().toLowerCase())
          if(orgFound){
            this.defaultOrganization = orgFound;
            this.backOffice24StatesService.setCurrentOrg(this.defaultOrganization);
          }else{
            this.router.navigate(['/admin/backoffice24', this.myConfigService.myConfig.organizations[0]?.organizationId]);
          }
        }
        else if (this.defaultOrganization == null || this.defaultOrganization == undefined) {
          this.router.navigate(['/admin/backoffice24', this.myConfigService.myConfig.organizations[0]?.organizationId]);
          this.defaultOrganization = this.myConfigService.myConfig.organizations[0];
          // this.backOffice24StatesService.setCurrentOrg(this.defaultOrganization);
        }
        this.goToOrganizationTabByQuery();

        this.loadingInitConfig = false;
      }
    });

  }

  
  get visibleOrganizations() {
    return this.myConfigService?.myConfig?.organizations
      ?.filter(org => org?.config?.backOfficeModules?.length > 0) ?? [];
  }


  public goToOrganizationTabByQuery(isMeTab?: boolean) {
    for (let i = 0; i < this.visibleOrganizations.length; i++) {
      // this.demo1TabNext();
      if (this.visibleOrganizations[i]?.organizationId == this.defaultOrganization?.organizationId) {
        this.backOffice24StatesService.setCurrentOrg(this.visibleOrganizations[i]);
        this.demo1TabIndex = i;
      }
    }
    // const tabCount = this.myConfigService.myConfig.organizations.length;
    // this.demo1TabIndex = (this.demo1TabIndex + 1) % tabCount;
  }

  sendMessage(): void {
    const message = new Message();
    message.message = 'CJHUB';
    message.type = 'TEST';
    message.date = new Date();
    this.cjHubService.sendMessage(message);
    console.log('connectionDetails', this.cjHubService.connectionDetails);
    console.log('cjHubService', this.cjHubService);
  }

  refreshToken() {
    this.stateService.refreshToken();
  }

  refreshMyConfig() {
    this.stateService.getAndSetMyConfig();
  }

  testOrganizations() {
    return this.backOfficeService.getOneOrganizations().pipe(takeUntil(this.componentDestroyed$))
    .subscribe(organizations => {
      alert('Organizations fetched');
      console.log('organizations:', organizations);
    },
      error => {
        console.error('Error getting organization:', error);
      }
    );
  }

  testUsers() {
    const filter: OneUsersPaginationModel = {
      // Paginate: {
      //   PerPage: 20,
      //   Page: 1
      // },
      // NoOrganizationMember: false, //Search for users that are not members of any organization
      // OnlyOrganizationMember: false, //Search for users that are members of any organization
      // SiteAccessLevel: 1, //Search for users that have a specific access level (1=Administrator)
      // IsLockedOut: true, //Search for users that are locked out
      // IsActive: false, //Search for user accounts that are active
      // SortingColumn: 'Created', //Created,AccessLevel,Name,Mobile,Email,LastLogin,LastLockedOutDate
      // SortingDirection: 'asc', //asc, desc
       SmsVerification: false, //Search for users that use the SMS code for logging in
      // OrganizationIds: ["a848ccd3-fd8d-4035-925e-571ebb4e93e8","417596f5-8fe5-4fa7-84dc-0af0ace72cf1"],
      // EmailSearch: "tiru", //Search for users by email address
      // NameSearch: "tiru", //Search for users by name
      // MobileSearch: "729", //Search for users by mobile number
      // RoleSearch: "SiteAdmin" //Administrator, SiteAdmin
      // OrganizationMemberType: 1, (This one is primary, OrganizationMemberTypeName is secondary)
      OrganizationMemberTypeName: 'ParkiflyAdministrator'
    };
    return this.backOfficeService.getOneUsers(filter).pipe(takeUntil(this.componentDestroyed$))
    .subscribe(users => {
      // alert('Users fetched');
      console.log('users:', users);
    },
      error => {
        console.error('Error getting users:', error);
      }
    );
  }

  canShowModule(moduleName: string, organization: MyConfigOrganization): boolean {
    return this.myConfigService.hasModuleAccess(moduleName, organization, false);
  }

  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
  }

  setOrganizationId(data) {
    if (data == this.myConfigService.myConfig.organizations.length) {
      this.router.navigate(['/admin/backoffice24/Me']);
      return;
    }
    this.router.navigate(['/admin/backoffice24', this.visibleOrganizations[data]?.organizationId]);
  }

  selectOrg(org: 'flygets' | 'skavsta' | 'mdpark') {
    this.bookingConfig.setOrganization(org).then(() => {
      this.router.navigate([this.bookingConfig.getConfig().baseUrl]);
      // window.open(this.bookingConfig.getConfig().baseUrl, '_blank');
    });
  }

  changeOrganization(organizationId: string) {
    this.router.navigate(['/admin/backoffice24', organizationId]);
  }

  openDebug(): void {
    const dialogRef = this.dialog.open(DebugModalComponent, {
      position: { right: '5px', left: '5px', top: '65px', bottom: '65px' },
      hasBackdrop: true
    });
    const sub = dialogRef.componentInstance.onAdd.subscribe((data: string) => { });
    dialogRef.afterClosed().subscribe(result => {
      sub.unsubscribe();
    });
  }

}
